import React, { Fragment } from "react";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import styles from "../ProfileForm.module.less";
import RadioFormGroup from "assets/scripts/components/common/form/RadioFormGroup/RadioFormGroup";
import classNames from "classnames";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
const messages = defineMessages({
    okEmailGroupLabel: {
        id: "profile.okEmail.groupLabel",
        defaultMessage: "I authorize DCM Services"
    },
    okEmailYes: {
        id: "profile.okEmail.yes",
        defaultMessage: "Yes"
    },
    okEmailNo: {
        id: "profile.okEmail.no",
        defaultMessage: "No"
    },
    okEmailConfirm: {
        id: "profile.okEmail.confirm",
        defaultMessage: "Confirm"
    },
    phone: {
        id: "profile.okEmail.authorize2.phone",
        defaultMessage: "1-877-326-8784"
    },
    phoneUrl: {
        id: "profile.okEmail.authorize2.phone.url",
        defaultMessage: "tel:+18773268784"
    }
});
const okEmailOptions = [
    {
        value: "yes",
        label: messages.okEmailYes
    },
    {
        value: "no",
        label: messages.okEmailNo
    }
];
export function getErrors(value) {
    return {
        okEmail: value.okEmail == null ? REQUIRED : null
    };
}
export default injectIntl(function ProfileOkEmailInput({ deceased, value, errors, backendErrors, onChange, intl }) {
    const handleChange = (okEmail) => onChange({
        ...value,
        okEmail: okEmail === "" ? null : okEmail === "yes"
    });
    return (<Fragment>
			<div className={styles.okEmail}>
				{process.env.CLIENT !== "CapOne" && deceased && (<FormattedMessage tagName="p" id="profile.okEmail.authorize1" defaultMessage={"I authorize DCM Services, LLC (DCMS), debt collector, to contact me with the information "
        + "I provided (e-mail, phone, address) in an attempt to collect the debt from the estate. "
        + "I understand that any information provided will be used for that purpose."}/>)}
				{process.env.CLIENT !== "CapOne" && !deceased && (<FormattedMessage tagName="p" id="profile.okEmail.authorize1.live" defaultMessage={"I authorize DCM Services, LLC (DCMS), debt collector, to contact me with the information "
        + "I provided (e-mail, phone, address) in an attempt to collect the debt. I understand "
        + "that any information I provide will be used for that purpose."}/>)}

				<FormattedMessage tagName="p" id="profile.okEmail.authorize2" defaultMessage={"You can opt out of email using one of the following ways, at any time. "
        + "It may take up to 24 hours from receipt of such a request to be completed on our system."} values={{
        phone: (<a href={intl.formatMessage(messages.phoneUrl)} itemProp="telephone" className="linkTel">
								{intl.formatMessage(messages.phone)}
							</a>)
    }}/>

				{process.env.CLIENT !== "CapOne" && (<ol type="1" className="list-numbered ">
						<FormattedMessage tagName="li" id="profile.okEmail.authorize2.a" defaultMessage={"Through the Email Preferences section of site once logged in"}/>
						<FormattedMessage tagName="li" id="profile.okEmail.authorize2.b" defaultMessage={"Through the opt-out hyperlink received in the email communication, or"}/>
						<FormattedMessage tagName="li" id="profile.okEmail.authorize2.c" defaultMessage={"Call DCMS tollfree at 1-877-326-8786"}/>
					</ol>)}

				<FormattedMessage tagName="p" id="profile.okEmail.authorize3" defaultMessage={"Once you opt out, DCMS will not communicate with you via email nor will it be able to email "
        + "you for the limited purpose of providing you with site access (e.g., username retrieval, "
        + "password resets) unless you give DCMS permission."}/>

				{process.env.CLIENT === "CapOne" && deceased && (<FormattedMessage tagName="p" id="profile.okEmail.authorize1" defaultMessage={"I authorize DCM Services, LLC (DCMS), debt collector, to contact me with the information "
        + "I provided (e-mail, phone, address) in an attempt to collect the debt from the estate. "
        + "I understand that any information provided will be used for that purpose."}/>)}
				{process.env.CLIENT === "CapOne" && !deceased && (<FormattedMessage tagName="p" id="profile.okEmail.authorize1.live" defaultMessage={"I authorize DCM Services, LLC (DCMS), debt collector, to contact me with the information "
        + "I provided (e-mail, phone, address) in an attempt to collect the debt. I understand "
        + "that any information I provide will be used for that purpose."}/>)}
			</div>
			<fieldset>
				<legend className="u-isVisuallyHidden">
					<FormattedMessage {...messages.okEmailConfirm}/>
				</legend>

				<RadioFormGroup name="okEmail" className={classNames("form-group-okEmail", styles.okEmailFormGroup)} label={(<span className="u-isVisuallyHidden">
							<FormattedMessage {...messages.okEmailConfirm}/>
						</span>)} value={(value.okEmail == null ? ""
        : value.okEmail ? "yes"
            : "no")} onChange={handleChange} options={okEmailOptions} error={errors.okEmail} backendError={backendErrors.canSendCollectionEmail} suppressAria/>
			</fieldset>
		</Fragment>);
});



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfileOkEmailInput/ProfileOkEmailInput.tsx